import { createHttpMutationAdapter } from '@/lib/adapters/httpMutationAdapter';

export const httpDeleteAdapter = createHttpMutationAdapter('delete');
